/*
 * Copyright (c) Worldline 2023.
 */

export const PartRight = {
    toDownload: 'TO_DOWNLOAD',
    toDisplay: 'TO_DISPLAY'
}